var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mia-has-feature',{attrs:{"feature":"lead_potentials"}},[_c('mia-menu-item',{attrs:{"to":{ name: 'leads.settings.potentials' },"icon":"layout-module-1","without-progress":""}},[_vm._v("\n      Potentiale\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }